<template>
  <v-app>
    <Navbar/>
    <router-view/>
    <v-main>
      <v-layout row class="mt-16">
        <v-flex xs1 sm1 md1 lg1></v-flex>
        <v-flex xs11 sm5 md4 lg3>
          <v-card flat outlined class="text-center"
                  style="width: 280px; margin-left: auto; margin-right: auto">
            <v-responsive class="pt-4">
              <v-avatar size="180" class="grey lighten-2" style="border:1px solid">
                <img src="/photo.png"/>
              </v-avatar>
            </v-responsive>
            <v-card-text>
              <div class="subheading">Weizhe Yuan</div>
              <div class="grey--text">ML/NLP, Painting</div>
              <v-divider class="ma-2"></v-divider>
              <!-- information -->
              <div class="mx-2 mb-1 subheading text-left">
                <v-icon left small>mdi-school</v-icon>
                <a
                    href="https://scholar.google.com/citations?user=2k5j4eMAAAAJ&hl=zh-CN"
                    target="_blank"
                    class="txt"
                >
                  <span>Google Scholar</span>
                </a>
              </div>
              <div class="mx-2 mb-1 subheading text-left">
                <v-icon left small>mdi-github</v-icon>
                <a
                    href="https://github.com/yyy-Apple"
                    target="_blank"
                    class="txt"
                >
                  <span>https://github.com/yyy-Apple</span>
                </a>
              </div>
              <div class="mx-2 mb-1 subheading text-left">
                <v-icon left small>mdi-twitter</v-icon>
                <a
                    href="https://twitter.com/WeizheY"
                    target="_blank"
                    class="txt"
                >
                  <span>@WeizheY</span>
                </a>
              </div>
              <div class="mx-2 subheading text-left">
                <v-icon left small>mdi-email</v-icon>
                <span>bellyapplerian@gmail.com</span>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm5 md6 lg6 class="mx-2 px-2">
          <p class="headline mb-2">About</p>
          <v-divider></v-divider>
          <p>
            Currently, I am a fourth-year Ph.D. student at <a href="https://www.nyu.edu/">New York University</a>
            advised by Prof. <a href="https://kyunghyuncho.me/">Kyunghyun Cho</a> and Prof.
            <a href="https://ai.facebook.com/people/jason-weston">Jason Weston</a>. My research mainly focuses on building self-improving, self-aligning language models. My long-time research goal is to develop intelligent systems for human goods.

<!--            My research experience-->
<!--            mainly focused on text generation and evaluation for NLP tasks but-->
<!--            I’m open to other areas as well. I currently work on self-training for large language models and alignment research in general. My long-time research goal is to-->
<!--            develop intelligent systems for human goods.-->
          </p>
<!--          My research experience-->
<!--            mainly focused on text generation and evaluation for NLP tasks but-->
<!--            I’m open to other areas as well-->
          <p>
            Before now, I was a Master’s student at
            <a href="https://www.cmu.edu/">Carnegie Mellon University</a>
            majoring computational data science. During my Master’s period, I
            worked closely with Dr.
            <a href="http://pfliu.com/">Pengfei Liu</a> and Prof.
            <a href="http://www.phontron.com/">Graham Neubig</a> and developed
            my interest in natural language processing.
          </p>
          <p>
            I received my Bachelor’s degree from
            <a href="https://en.whu.edu.cn/">Wuhan University</a>

            in 2019, majoring civil engineering and computer science.
          </p>

          <p class="headline mb-2 mt-3">News</p>
          <v-divider></v-divider>
          <ul>
            <li>
              <span class="time">2025.05.08</span>
              Gave a talk on
              <a href="https://arxiv.org/abs/2401.10020" target="_blank"
              >Self-Rewarding Language Models</a
              >
              at Samsung, Mila, and NYU GRP Workshop
            </li>
            <li>
              <span class="time">2024.03.08</span>
              Gave a talk on
              <a href="https://arxiv.org/abs/2401.10020" target="_blank"
              >Self-Rewarding Language Models</a
              >
              at Meta
            </li>
            <li>
              <span class="time">2022.05.22</span>
              Received the <strong>Outstanding Demo Paper Award</strong> at ACL 2022 &#127942;
            </li>
<!--            <li>-->
<!--              <span class="time">2021.12.01</span>-->
<!--              One <a href="https://ojs.aaai.org/index.php/AAAI/article/view/21418">paper</a> accepted to AAAI 2022-->
<!--              &#127881;-->
<!--            </li>-->
<!--            <li>-->
<!--              <span class="time">2021.09.29</span>-->
<!--              One <a href="https://arxiv.org/abs/2106.11520">paper</a> accepted to NeurIPS 2021 &#127881;-->
<!--            </li>-->
            <li>
              <span class="time">2021.07.28</span>
              Released a
              <a href="https://arxiv.org/abs/2107.13586" target="_blank"
              >survey</a
              >
              regarding prompt-based learning
            </li>
            <li>
              <span class="time">2021.07.20</span>
              Received the <strong>Best Demo Paper Award</strong> at ACL 2021 &#127942;
            </li>
            <li>
              <span class="time">2021.07.12</span>
              Gave a talk on
              <a href="https://arxiv.org/abs/2106.11520" target="_blank"
              >BARTScore: Evaluating Generated Text as Text Generation</a
              >
              at Unbabel
            </li>
          </ul>

          <p class="headline mb-2 mt-3">Working Experience</p>
          <v-divider></v-divider>
          <ul>
            <li>
              <span class="time">2023.9 - Now</span>
              Visiting Researcher, Meta
            </li>
            <li>
              <span class="time">2023.6 - 2023.8</span>
              Intern of Technical Staff, Cohere
            </li>
          </ul>


          <p class="headline mb-2 mt-3">Selected Publications</p>
          <v-divider></v-divider>
          <p style="color: gray">
            <i>My full list of publications can be found on <a
                href="https://scholar.google.com/citations?user=2k5j4eMAAAAJ" target="_blank">Google Scholar</a>.</i>
          </p>
          <!--    NaturalReasoning     -->
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-wrap"
              >NaturalReasoning: Reasoning in the Wild with 2.8M Challenging Questions
              </v-list-item-title
              >
              <v-list-item-subtitle class="text-wrap"
              ><strong>Weizhe Yuan</strong>, Jane Yu, Song Jiang, Karthik Padthe, Yang Li, Ilia Kulikov, Kyunghyun Cho, Dong Wang, Yuandong Tian, Jason E Weston, Xian Li
              </v-list-item-subtitle
              >
              <v-list-item-subtitle class="conference"
              ><i>Arxiv 2025</i>
                <v-chip
                    small
                    label
                    color="success"
                    class="mx-1"
                    outlined
                    link
                    href="https://huggingface.co/datasets/facebook/natural_reasoning"
                    target="_blank"
                >data
                </v-chip
                >
                <v-chip
                    small
                    label
                    color="orange"
                    class="mx-1"
                    outlined
                    link
                    href="https://arxiv.org/abs/2502.13124"
                    target="_blank"
                >paper
                </v-chip
                >
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <!--    Lenctrl     -->
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-wrap"
              >Following Length Constraints in Instructions
              </v-list-item-title
              >
              <v-list-item-subtitle class="text-wrap"
              ><strong>Weizhe Yuan</strong>, Ilia Kulikov, Ping Yu, Kyunghyun Cho, Sainbayar Sukhbaatar, Jason Weston, Jing Xu
              </v-list-item-subtitle
              >
              <v-list-item-subtitle class="conference"
              ><i>EMNLP 2025</i>
                <v-chip
                    small
                    label
                    color="success"
                    class="mx-1"
                    outlined
                    link
                    href="https://github.com/facebookresearch/RAM/tree/main/projects/length_instruct"
                    target="_blank"
                >code
                </v-chip
                >
                <v-chip
                    small
                    label
                    color="orange"
                    class="mx-1"
                    outlined
                    link
                    href="https://arxiv.org/abs/2406.17744"
                    target="_blank"
                >paper
                </v-chip
                >
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>


          <!--    Self-rewarding Language Models     -->
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-wrap"
              >Self-Rewarding Language Models
              </v-list-item-title
              >
              <v-list-item-subtitle class="text-wrap"
              ><strong>Weizhe Yuan</strong>, Richard Yuanzhe Pang, Kyunghyun Cho, Xian Li, Sainbayar Sukhbaatar, Jing Xu, Jason Weston
              </v-list-item-subtitle
              >
              <v-list-item-subtitle class="conference"
              ><i>ICML 2024</i>
                <!--                <v-chip-->
                <!--                    small-->
                <!--                    label-->
                <!--                    color="success"-->
                <!--                    class="mx-1"-->
                <!--                    outlined-->
                <!--                    link-->
                <!--                    href="https://github.com/qinyiwei/T5Score"-->
                <!--                    target="_blank"-->
                <!--                >code-->
                <!--                </v-chip-->
                <!--                >-->
                <v-chip
                    small
                    label
                    color="orange"
                    class="mx-1"
                    outlined
                    link
                    href="https://arxiv.org/abs/2401.10020"
                    target="_blank"
                >paper
                </v-chip
                >
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <!--    Sys-level NL feedback     -->
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-wrap"
              >System-Level Natural Language Feedback
              </v-list-item-title
              >
              <v-list-item-subtitle class="text-wrap"
              ><strong>Weizhe Yuan</strong>, Kyunghyun Cho, Jason Weston
              </v-list-item-subtitle
              >
              <v-list-item-subtitle class="conference"
              ><i>EACL 2024</i>
                <v-chip
                    small
                    label
                    color="success"
                    class="mx-1"
                    outlined
                    link
                    href="https://github.com/yyy-Apple/Sys-NL-Feedback"
                    target="_blank"
                >code
                </v-chip
                >
                <v-chip
                    small
                    label
                    color="orange"
                    class="mx-1"
                    outlined
                    link
                    href="https://arxiv.org/abs/2306.13588"
                    target="_blank"
                >paper
                </v-chip
                >
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

<!--          &lt;!&ndash;    T5Score     &ndash;&gt;-->
<!--          <v-list-item two-line>-->
<!--            <v-list-item-content>-->
<!--              <v-list-item-title class="text-wrap"-->
<!--              >T5Score: Discriminative Fine-tuning of Generative Evaluation Metrics-->
<!--              </v-list-item-title-->
<!--              >-->
<!--              <v-list-item-subtitle class="text-wrap"-->
<!--              >Yiwei Qin, <strong>Weizhe Yuan</strong>, Graham Neubig, Pengfei Liu-->
<!--              </v-list-item-subtitle-->
<!--              >-->
<!--              <v-list-item-subtitle class="conference"-->
<!--              ><i>ArXiv 2022</i>-->
<!--                <v-chip-->
<!--                    small-->
<!--                    label-->
<!--                    color="success"-->
<!--                    class="mx-1"-->
<!--                    outlined-->
<!--                    link-->
<!--                    href="https://github.com/qinyiwei/T5Score"-->
<!--                    target="_blank"-->
<!--                >code-->
<!--                </v-chip-->
<!--                >-->
<!--                <v-chip-->
<!--                    small-->
<!--                    label-->
<!--                    color="orange"-->
<!--                    class="mx-1"-->
<!--                    outlined-->
<!--                    link-->
<!--                    href="https://arxiv.org/abs/2212.05726"-->
<!--                    target="_blank"-->
<!--                >paper-->
<!--                </v-chip-->
<!--                >-->
<!--              </v-list-item-subtitle>-->
<!--            </v-list-item-content>-->
<!--          </v-list-item>-->

          <!--    RST     -->
<!--          <v-list-item two-line>-->
<!--            <v-list-item-content>-->
<!--              <v-list-item-title class="text-wrap"-->
<!--              >reStructured Pre-training-->
<!--              </v-list-item-title-->
<!--              >-->
<!--              <v-list-item-subtitle class="text-wrap"-->
<!--              ><strong>Weizhe Yuan</strong> and Pengfei Liu-->
<!--              </v-list-item-subtitle-->
<!--              >-->
<!--              <v-list-item-subtitle class="conference"-->
<!--              ><i>ArXiv 2022</i>-->
<!--                <v-chip-->
<!--                    small-->
<!--                    label-->
<!--                    color="success"-->
<!--                    class="mx-1"-->
<!--                    outlined-->
<!--                    link-->
<!--                    href="https://github.com/ExpressAI/reStructured-Pretraining"-->
<!--                    target="_blank"-->
<!--                >code-->
<!--                </v-chip-->
<!--                >-->
<!--                <v-chip-->
<!--                    small-->
<!--                    label-->
<!--                    color="orange"-->
<!--                    class="mx-1"-->
<!--                    outlined-->
<!--                    link-->
<!--                    href="https://arxiv.org/abs/2206.11147"-->
<!--                    target="_blank"-->
<!--                >paper-->
<!--                </v-chip-->
<!--                >-->
<!--              </v-list-item-subtitle>-->
<!--            </v-list-item-content>-->
<!--          </v-list-item>-->

          <!--      DataLab-->
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-wrap"
              >DataLab: A Platform for Data Analysis and Intervention
              </v-list-item-title
              >
              <v-list-item-subtitle class="text-wrap"
              >Yang Xiao, Jinlan Fu, <strong>Weizhe Yuan</strong>, Vijay Viswanathan, Zhoumianze Liu, Yixin Liu, Graham
                Neubig, Pengfei Liu
              </v-list-item-subtitle
              >
              <v-list-item-subtitle class="conference"
              ><i>ACL 2022</i>
                <v-chip
                    small
                    label
                    color="success"
                    class="mx-1"
                    outlined
                    link
                    href="https://github.com/ExpressAI/DataLab"
                    target="_blank"
                >code
                </v-chip
                >
                <v-chip
                    small
                    label
                    color="orange"
                    class="mx-1"
                    outlined
                    link
                    href="https://arxiv.org/abs/2202.12875"
                    target="_blank"
                >paper
                </v-chip
                >
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <!--&lt;!&ndash;    KidReview   &ndash;&gt;-->
          <!--          <v-list-item two-line>-->
          <!--            <v-list-item-content>-->
          <!--              <v-list-item-title class="text-wrap"-->
          <!--              >KID-Review: Knowledge-guided Scientific Review Generation with Oracle Pre-training-->
          <!--              </v-list-item-title-->
          <!--              >-->
          <!--              <v-list-item-subtitle class="text-wrap"-->
          <!--              ><strong>Weizhe Yuan</strong> and Pengfei Liu-->
          <!--              </v-list-item-subtitle-->
          <!--              >-->
          <!--              <v-list-item-subtitle class="conference"-->
          <!--              ><i>AAAI 2022</i>-->
          <!--                <v-chip-->
          <!--                    small-->
          <!--                    label-->
          <!--                    color="success"-->
          <!--                    class="mx-1"-->
          <!--                    outlined-->
          <!--                    link-->
          <!--                    href="https://github.com/yyy-Apple/KIDReview"-->
          <!--                    target="_blank"-->
          <!--                >code-->
          <!--                </v-chip-->
          <!--                >-->
          <!--                <v-chip-->
          <!--                    small-->
          <!--                    label-->
          <!--                    color="orange"-->
          <!--                    class="mx-1"-->
          <!--                    outlined-->
          <!--                    link-->
          <!--                    href="https://ojs.aaai.org/index.php/AAAI/article/view/21418"-->
          <!--                    target="_blank"-->
          <!--                >paper-->
          <!--                </v-chip-->
          <!--                >-->
          <!--              </v-list-item-subtitle>-->
          <!--            </v-list-item-content>-->
          <!--          </v-list-item>-->


          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-wrap"
              >Pre-train, Prompt, and Predict: A Systematic Survey of
                Prompting Methods in Natural Language
                Processing
              </v-list-item-title
              >
              <v-list-item-subtitle class="text-wrap"
              >Pengfei Liu, <strong>Weizhe Yuan</strong>, Jinlan Fu, Zhengbao
                Jiang, Hiroaki Hayashi, Graham Neubig
              </v-list-item-subtitle
              >
              <v-list-item-subtitle class="conference"
              ><i>ACM Computing Surveys 2023</i>
                <v-chip
                    small
                    label
                    color="success"
                    class="mx-1"
                    outlined
                    link
                    href="https://github.com/pfliu-nlp/NLPedia-Pretrain"
                    target="_blank"
                >code
                </v-chip
                >
                <v-chip
                    small
                    label
                    color="orange"
                    class="mx-1"
                    outlined
                    link
                    href="https://arxiv.org/abs/2107.13586"
                    target="_blank"
                >paper
                </v-chip
                >
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-wrap"
              >BARTScore: Evaluating Generated Text as Text
                Generation
              </v-list-item-title
              >
              <v-list-item-subtitle class="text-wrap"
              ><strong>Weizhe Yuan</strong>, Graham Neubig, Pengfei
                Liu
              </v-list-item-subtitle
              >
              <v-list-item-subtitle class="conference"
              ><i>NeurIPS 2021</i>
                <v-chip
                    small
                    label
                    color="success"
                    class="mx-1"
                    outlined
                    link
                    href="https://github.com/neulab/BARTScore"
                    target="_blank"
                >code
                </v-chip
                >
                <v-chip
                    small
                    label
                    color="orange"
                    class="mx-1"
                    outlined
                    link
                    href="https://arxiv.org/abs/2106.11520"
                    target="_blank"
                >paper
                </v-chip
                >
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-wrap"
              >ExplainaBoard: An Explainable Leaderboard for
                NLP
              </v-list-item-title
              >
              <v-list-item-subtitle class="text-wrap"
              >Pengfei Liu, Jinlan Fu, Yang Xiao,
                <strong>Weizhe Yuan</strong>, Shuaicheng Chang, Junqi Dai, Yixin
                Liu, Zihuiwen Ye, Zi-Yi Dou, Graham Neubig
              </v-list-item-subtitle
              >
              <v-list-item-subtitle class="conference"
              ><i>ACL 2021</i> <strong>Best Demo Paper</strong>
                <v-chip
                    small
                    label
                    color="success"
                    class="mx-1"
                    outlined
                    link
                    href="https://github.com/neulab/ExplainaBoard"
                    target="_blank"
                >code
                </v-chip
                >
                <v-chip
                    small
                    label
                    color="orange"
                    class="mx-1"
                    outlined
                    link
                    href="https://arxiv.org/abs/2104.06387"
                    target="_blank"
                >paper
                </v-chip
                >
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-wrap"
              >Can We Automate Scientific Reviewing?
              </v-list-item-title
              >
              <v-list-item-subtitle class="text-wrap"
              ><strong>Weizhe Yuan</strong>, Pengfei Liu, Graham
                Neubig
              </v-list-item-subtitle
              >
              <v-list-item-subtitle class="conference"
              ><i>JAIR 2022</i>
                <v-chip
                    small
                    label
                    color="success"
                    class="mx-1"
                    outlined
                    link
                    href="https://github.com/neulab/ReviewAdvisor"
                    target="_blank"
                >code
                </v-chip
                >
                <v-chip
                    small
                    label
                    color="orange"
                    class="mx-1"
                    outlined
                    link
                    href="https://arxiv.org/abs/2102.00176"
                    target="_blank"
                >paper
                </v-chip
                >
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <p class="headline mb-2 mt-3">Education Background</p>
          <v-divider></v-divider>
          <ul>
            <li>
              <span class="time">Sep. 2022 - Now</span> Ph.D. in Computer and Information Sciences,
              New York University
            </li>
            <li>
              <span class="time">Sep. 2019 - May. 2021</span> Master of
              Computational Data Science, Carnegie Mellon University
            </li>
            <li>
              <span class="time">Feb. 2017 - Jun. 2019</span> B.E. in Computer
              Science, Wuhan University, China
            </li>
            <li>
              <span class="time">Sep. 2015 - Jun. 2019</span> B.E. in Civil
              Engineering, Wuhan University, China
            </li>
          </ul>
        </v-flex>
      </v-layout>
    </v-main>
    <a href="https://clustrmaps.com/site/1bd2u" title="Visit tracker"><img style="display:none"
                                                                           src="//www.clustrmaps.com/map_v2.png?d=V62E0hACfxwSOd3C90-rxco6sFhTb-yEaubS9G3Tc6Y&cl=ffffff"/></a>
  </v-app>
</template>

<script>
import Navbar from "./components/Navbar.vue";

export default {
  name: "App",
  components: {Navbar},
  data: () => ({
    //
  }),
};
</script>


<style>
.txt:hover {
  text-decoration: underline;
}

a {
  text-decoration: none;
  color: #ff0000;
}

div span,
a span {
  color: rgb(103, 114, 122);
}

/* p {
  word-spacing: 2px;
} */

span.time {
  color: rgb(235, 103, 158);
}
</style>